<template>
  <div>
    <p></p>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {};
  },

  mounted() {
    var from = this.util.vueGetQueryString("from");
    var gotoPath = this.util.vueGetQueryString("gotoPath");
    if (from == "whg") {
      this.whgLogin();
    } else if(from == "zjActive"){
      this.zjLogin();
      }else if (from == "new") {
      var code = this.util.vueGetQueryString("code");
      var state = this.util.vueGetQueryString("state");
      window.location.replace(
        "http://im.iartschool.com:10010/#/login/loginBoard?code=" +
          code +
          "&state=" +
          state
          // +(gotoPath?'&gotoPath='+gotoPath:'')
      );
    }else if(from=='tzActive'){
        this.tzLogin();
    } else {
      this.login();
    }
  },
  methods: {
    whgLogin() {
      var obj = {
        code: this.util.vueGetQueryString("code"),
        state: this.util.vueGetQueryString("state"),
      };
      var activityid = this.util.vueGetQueryString("activityid");
      var b2bcenterid = this.util.vueGetQueryString("b2bcenterid");
      this.$get("iart-api-b2b/b2b/oauth/app", obj)
        .then((res) => {
          if (this.util.vueGetQueryString("test")) {
            window.location.href =
              "http://test.iartschool.com:9292/live/live.html?openid=" +
              res.data.openid +
              "&&activityid=" +
              activityid +
              "&&b2bcenterid=" +
              b2bcenterid;
          } else {
            window.location.href =
              "https://b2b.iartschool.com/whg/live/live.html?openid=" +
              res.data.openid +
              "&&activityid=" +
              activityid +
              "&&b2bcenterid=" +
              b2bcenterid;
          }
        })
        .catch((res) => {});
    },
      tzLogin() {
      var obj = {
        code: this.util.vueGetQueryString("code"),
        state: this.util.vueGetQueryString("state"),
      };
      let path=decodeURIComponent(this.util.vueGetQueryString("path"));
      path+=path.indexOf('?')==-1?'?':'&'
      // console.log(path+'code='+this.util.vueGetQueryString("code")+'&state='+this.util.vueGetQueryString("state").split('?')[0])
      window.location.replace(path+'code='+this.util.vueGetQueryString("code")+'&state='+encodeURIComponent( this.util.vueGetQueryString("state").split('?')[0]))
          //  window.location.replace (path+'?code='+this.util.vueGetQueryString("code")+'&state='+this.util.vueGetQueryString("state").split('?')[0] );
    },
      zjLogin() {
      var obj = {
        code: this.util.vueGetQueryString("code"),
        state: this.util.vueGetQueryString("state"),
      };
      var id = this.util.vueGetQueryString("id");
      this.$get("/iart-sys-api/oauth/mp", obj)
        .then((res) => {
          if (this.util.vueGetQueryString("test")) {
            window.location.replace ("http://test.iartschool.com:9292/zjActive/html/work.html?openid=" +res.data.openid +"&id=" +id );
          } else {
           window.location.replace("http://b2b.iartschool.com/whg/zjActive/html/work.html?openid="+res.data.openid +"&id=" +id+'&customerid='+res.data.customerid);
          }
        })
        .catch((res) => {});
    },
    login() {
      var obj = {
        code: this.util.vueGetQueryString("code"),
        state: this.util.vueGetQueryString("state"),
      };
      this.$get("iart-api-authorize/wx/oauth/mp", obj)
        .then((res) => {
          if (res.code == 1) {
            var enterUrl = localStorage.getItem("enterUrl");
            localStorage.setItem("wechatLogin", 1);
            if (res.data.customercode) {
              localStorage.setItem("customercode", res.data.customercode);
            }
            if (res.data.rtncode == 60002) {
              window.location.href =
                window.location.origin +
                "/#/login/bindInfo?openid=" +
                res.data.openid;
            } else {
              if (enterUrl) {
                window.location.href = enterUrl;
                localStorage.removeItem("enterUrl");
              } else {
                window.location.href = window.location.origin + "/#/";
              }
            }
          } else {
            localStorage.removeItem("wechatLogin");
          }
        })
        .catch((res) => {
          localStorage.removeItem("wechatLogin");
        });
    },
  },
};
</script>

<style  scoped>
</style>